export default __webpack_public_path__ + "static/media/single-timezone-img1.99b519dc.png";